<template>
  <div class="row table-wrapper">
    <table class="table">
      <tr>
        <td v-for="j in columns" :key="j">
          <center>
            <PuSkeleton
              :duration="duration"
              height="15px"
              width="80px"
            ></PuSkeleton>
          </center>
        </td>
      </tr>
      <tr v-for="i in 9" :key="i">
        <td v-for="j in columns" :key="j">
          <center>
            <PuSkeleton :duration="duration" height="15px" width="60px" />
          </center>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
export default {
  name: "skeleton-table",
  props: {
    columns: {
      type: Number,
      default: 10
    },
    duration: {
      type: Number,
      default: 1.5
    }
  }
};
</script>

<style></style>
